/**
 * Hotel Rebstock chatbot — knowledge learning API (rebstockbot backend).
 *
 * Set in uni_admin_frontend/.env:
 *   REACT_APP_REBSTOCK_BOT_API_URL=https://rebstockbotnew.oxmite.com
 *   REACT_APP_REBSTOCK_KNOWLEDGE_KEY=<same as KNOWLEDGE_API_KEY on rebstockbot>
 */

function getRebstockApiUrl() {
  const url =
     "https://chatbotbackend.hotelrebstock.com";
  return url.replace(/\/$/, "");
}

function getKnowledgeKey() {
  return process.env.REACT_APP_REBSTOCK_KNOWLEDGE_KEY || "";
}

function knowledgeHeaders(json = true) {
  const headers = {};
  if (json) headers["Content-Type"] = "application/json";
  const key = getKnowledgeKey();
  if (key) headers["X-Knowledge-Key"] = key;
  return headers;
}

async function parseResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || data.message || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export function isRebstockKnowledgeConfigured() {
  return Boolean(getRebstockApiUrl() && getKnowledgeKey());
}

/** @returns {Promise<{ ok: boolean; content: string; characters: number }>} */
export async function fetchBaseKnowledge() {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge/base`, {
    headers: knowledgeHeaders(false),
  });
  return parseResponse(res);
}

/** @returns {Promise<{ ok: boolean; count: number; entries: Array }>} */
export async function fetchKnowledgeEntries() {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge`, {
    headers: knowledgeHeaders(false),
  });
  return parseResponse(res);
}

/** @returns {Promise<{ ok: boolean; totalCharacters: number }>} */
export async function fetchMergedPreview() {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge/merged/preview`, {
    headers: knowledgeHeaders(false),
  });
  return parseResponse(res);
}

/**
 * @param {{ title?: string; content: string; category?: string; tags?: string[] }} payload
 */
export async function createKnowledgeEntry(payload) {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge`, {
    method: "POST",
    headers: knowledgeHeaders(),
    body: JSON.stringify(payload),
  });
  return parseResponse(res);
}

/**
 * @param {string} id
 * @param {{ title?: string; content?: string; category?: string; tags?: string[] }} patch
 */
export async function updateKnowledgeEntry(id, patch) {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge/${id}`, {
    method: "PUT",
    headers: knowledgeHeaders(),
    body: JSON.stringify(patch),
  });
  return parseResponse(res);
}

/** @param {string} id */
export async function deleteKnowledgeEntry(id) {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge/${id}`, {
    method: "DELETE",
    headers: knowledgeHeaders(false),
  });
  return parseResponse(res);
}

export async function reindexKnowledge() {
  const res = await fetch(`${getRebstockApiUrl()}/api/knowledge/reindex`, {
    method: "POST",
    headers: knowledgeHeaders(false),
  });
  return parseResponse(res);
}

export function getRebstockApiDisplayUrl() {
  return getRebstockApiUrl();
}
